(() => {
  const root = document.querySelector('[data-ephilo-global-sound]');
  if (!root || window.ephiloGlobalSound || /\/checkouts?(\/|$)/.test(location.pathname)) return;
  window.ephiloGlobalSound = true;
  const button = root.querySelector('button');
  const state = root.querySelector('[data-sound-state]');
  const preferenceKey = 'ephiloMusicPreference';
  const positionKey = 'ephiloMusicPosition-ifAsK6aYJyA';
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
  let preference = read('localStorage', preferenceKey);
  let wantsPlay = preference !== 'off';
  let playing = false;
  let player = null;
  let ready = false;
  let loading = false;
  let resumeAfterHidden = false;
  let lastSave = 0;
  let suppressRestart = false;
  function updateUI(value) {
    playing = value;
    state.textContent = value ? root.dataset.onState : root.dataset.offState;
    button.setAttribute('aria-pressed', String(value));
    button.setAttribute('aria-label', value ? root.dataset.offLabel : root.dataset.onLabel);
  }
  function savePosition() {
    if (!ready || !player) return;
    try {
      const time = player.getCurrentTime();
      if (Number.isFinite(time) && time >= 0) write('sessionStorage', positionKey, String(time));
    } catch {}
  }
  function attemptPlay() {
    if (!ready || !wantsPlay || document.hidden || suppressRestart) return;
    try { player.playVideo(); } catch { updateUI(false); }
  }
  function createPlayer() {
    if (player || !window.YT?.Player) return;
    const host = document.createElement('div');
    host.id = 'ephilo-global-music-player';
    host.style.cssText = 'position:fixed;width:1px;height:1px;left:-9999px;bottom:0;overflow:hidden;pointer-events:none';
    host.setAttribute('aria-hidden', 'true');
    document.body.appendChild(host);
    player = new window.YT.Player(host.id, {
      height: '1', width: '1', videoId: 'ifAsK6aYJyA',
      playerVars: {autoplay: 0, controls: 0, disablekb: 1, fs: 0, playsinline: 1, rel: 0, origin: location.origin},
      events: {
        onReady(event) {
          ready = true;
          event.target.setVolume(12);
          const saved = Number(read('sessionStorage', positionKey));
          const duration = event.target.getDuration();
          if (Number.isFinite(saved) && saved > 0) event.target.seekTo(duration > 0 ? saved % duration : saved, true);
          if (wantsPlay && !document.hidden && !suppressRestart) attemptPlay();
          else event.target.pauseVideo();
          const iframe = event.target.getIframe();
          iframe.setAttribute('tabindex', '-1');
          iframe.setAttribute('aria-hidden', 'true');
        },
        onStateChange(event) {
          if (event.data === 1) {
            if (!wantsPlay || document.hidden || suppressRestart) { event.target.pauseVideo(); return; }
            updateUI(true);
            preference = 'on';
            write('localStorage', preferenceKey, preference);
          } else if (event.data === 2) { savePosition(); updateUI(false); }
          else if (event.data === 0) {
            updateUI(false);
            write('sessionStorage', positionKey, '0');
            if (wantsPlay && !document.hidden && !suppressRestart) { event.target.seekTo(0, true); attemptPlay(); }
          }
        },
        onAutoplayBlocked() { updateUI(false); },
        onError() { updateUI(false); }
      }
    });
  }
  function loadPlayer() {
    if (window.YT?.Player) { createPlayer(); attemptPlay(); return; }
    if (loading) return;
    loading = true;
    const previous = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      try { if (typeof previous === 'function') previous(); } finally { createPlayer(); }
    };
    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      script.onerror = () => { loading = false; script.remove(); updateUI(false); };
      document.head.appendChild(script);
    }
  }
  button.addEventListener('click', () => {
    if (playing) {
      wantsPlay = false;
      resumeAfterHidden = false;
      preference = 'off';
      write('localStorage', preferenceKey, preference);
      savePosition();
      if (ready) player.pauseVideo();
      updateUI(false);
    } else {
      wantsPlay = true;
      suppressRestart = false;
      preference = 'on';
      write('localStorage', preferenceKey, preference);
      loadPlayer();
      attemptPlay();
    }
  });
  function firstInteraction(event) {
    if (!event.isTrusted || root.contains(event.target) || !wantsPlay || suppressRestart) return;
    loadPlayer();
    attemptPlay();
  }
  document.addEventListener('pointerup', firstInteraction, {passive: true});
  document.addEventListener('keydown', firstInteraction);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      resumeAfterHidden = playing;
      savePosition();
      if (ready && playing) player.pauseVideo();
    } else if (resumeAfterHidden && wantsPlay) {
      resumeAfterHidden = false;
      attemptPlay();
    }
  });
  document.addEventListener('play', event => {
    if (event.target instanceof HTMLMediaElement && !event.target.muted) {
      suppressRestart = true;
      savePosition();
      if (ready) player.pauseVideo();
      updateUI(false);
    }
  }, true);
  window.addEventListener('pagehide', savePosition);
  window.addEventListener('pageshow', event => { if (event.persisted && wantsPlay) attemptPlay(); });
  window.addEventListener('storage', event => {
    if (event.key === preferenceKey && event.newValue === 'off') {
      preference = 'off'; wantsPlay = false;
      savePosition();
      if (ready) player.pauseVideo();
      updateUI(false);
    }
  });
  window.setInterval(() => { if (playing && Date.now() - lastSave >= 2000) { savePosition(); lastSave = Date.now(); } }, 2000);
  loadPlayer();})();
